/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import * as uxstackpb from '@uxstack/sdk-proto-js/uxstack/sdk/v1/sdk_pb';

export class EventContextLocation extends uxstackpb.EventContextLocation {
  constructor() {
    super({ title: document.title });

    this.url = this.getCanonicalUrl();

    if (document.referrer !== '') {
      this.referrer = document.referrer;
    }
  }

  private getCanonicalUrl(): string {
    // tslint:disable:object-literal-sort-keys
    const selectors: { [key: string]: string } = {
      '[rel="canonical"]': 'href',
      '[property="og:url"]': 'content',
      '[name="twitter:url"]': 'content',
      '[property="al:web:url"]': 'content',
    };

    for (const selector in selectors) {
      if (selectors.hasOwnProperty(selector)) {
        const property = selectors[selector];

        const elm = document.querySelector(selector) as { [key: string]: any };
        if (elm != null && elm[property].length > 0) {
          return elm[property];
        }
      }
    }

    return document.location.href;
  }
}
